var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99997 4.94253C5.41842 4.94253 6.5683 3.83611 6.5683 2.47127C6.5683 1.10642 5.41842 0 3.99997 0C2.58152 0 1.43164 1.10642 1.43164 2.47127C1.43164 3.83611 2.58152 4.94253 3.99997 4.94253Z",
    fill: "#62C776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61931 8.65674C5.2758 9.01925 3.34478 9.20069 1.38069 8.65674C0.615714 8.44497 0 7.97386 0 7.29771C0 6.61539 0.637509 6.18529 1.40015 5.93644C2.97465 5.42245 4.72878 5.36047 6.59985 5.93644C7.36716 6.17255 8 6.61539 8 7.29771C8 7.97386 7.38623 8.44983 6.61931 8.65674Z",
    fill: "#62C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona);
export default __webpack_public_path__ + "static/media/persona.f841dbbeafdd1d87225389a9a3a7defa.svg";
export { ForwardRef as ReactComponent };